import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, OnInit, OnDestroy
} from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';

import { ExchangeBookPayload, ExchangeSearchParamsSectors } from '@user-history/entities/user-history-item';
import { FlightResultsFacade } from '@flight-results/flight-results.facade';
import { FlightItem } from '@app/entities/flight-results';
import { ANIMATIONS, TIME_TO_SLIDE } from '@app/constants/animations.constants';
import { AppFacade } from '@app/app.facade';
import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';
import { ReservationType } from '@user-history/entities/user-history-item';
import { userHistoryRoute, userHistoryDetailRoute } from '@user-history/constants/history-routes.constants';
import { User } from '@app/modules/core/interfaces/user';
import { residualExchangePushMessageMapper } from '@notifications/slack/mappers/residual-exchange-push.mapper';

@Component({
  selector: 'app-flight-residual-exchange',
  templateUrl: './flight-residual-exchange.container.html',
  styleUrls: ['./flight-residual-exchange.container.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FlightResidualExchangeContainer implements OnInit, OnDestroy {

  public animation: string = ANIMATIONS.SLIDE_IN_BOTTOM;
  public confirmViewAnimation: string = ANIMATIONS.SLIDE_IN_BOTTOM;
  public termsAnimation: string = ANIMATIONS.SLIDE_IN_RIGHT;
  public loaderSuccessAnimation: string = ANIMATIONS.SLIDE_IN_RIGHT;

  public supportImg: string = 'ilustra-soporte.png';
  public fadeOut: boolean = false;
  public hiddenExchangeInfo: boolean = false;
  public showConfirmExchangePush: boolean = false;
  public showTerms: boolean = false;
  public showLoaderSuccess: boolean = false;
  public isMobile: boolean;

  private exchangePayload: ExchangeBookPayload;
  private selectedFlights: FlightItem[];
  private exchangeValue: number;
  private residualValue: number;
  private exchangeData: ExchangeSearchParamsSectors;

  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private domManipulateService: DomManipulateService,
    private facade: FlightResultsFacade,
    private appFacade: AppFacade
  ) {
    const state = this.router.getCurrentNavigation();
    if (state && state?.extras && state?.extras.state) {
      const { exchangePayload, selectedFlights, exchangeValue, residualValue, isMobile,
        exchangeData, hiddenExchangeInfo, showConfirmExchangePush } = this.router.getCurrentNavigation()?.extras?.state;
      this.exchangePayload = exchangePayload;
      this.selectedFlights = selectedFlights;
      this.exchangeValue = exchangeValue;
      this.residualValue = residualValue;
      this.isMobile = !!isMobile;
      this.exchangeData = exchangeData;
      this.hiddenExchangeInfo = !!hiddenExchangeInfo;
      this.showConfirmExchangePush = !!showConfirmExchangePush;
    }
  }

  ngOnInit(): void {
    this.domManipulateService.setBodyScroll(false);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  get user$(): Observable<User> {
    return this.appFacade.user$;
  }

  get isLoadingExchangePush$(): Observable<boolean> {
    return this.facade.isLoadingExchangePush$;
  }

  get successExchange$(): Observable<boolean> {
    return this.facade.successExchange$;
  }

  public closeAction(): void {
    this.animation = ANIMATIONS.SLIDE_OUT_BOTTOM;
    this.confirmViewAnimation = ANIMATIONS.SLIDE_OUT_BOTTOM;
    this.fadeOut = true;
    setTimeout(() => this.appFacade.navigateToLastRoute(), TIME_TO_SLIDE);
    this.domManipulateService.setBodyScroll(true);
  }

  public confirmExchangePush(): void {
    this.user$.pipe(take(1)).subscribe(user => {
      this.showLoaderSuccess = true;
      const payload = residualExchangePushMessageMapper(this.exchangePayload, this.exchangeData,
        this.selectedFlights, `${user.id}`, this.exchangeValue, this.residualValue);
      this.facade.slackResidualExchangePush(payload);
    }).unsubscribe();
  }

  public closeTerms(): void {
    this.termsAnimation = ANIMATIONS.SLIDE_OUT_RIGHT;
    setTimeout(() => this.showTerms = false, TIME_TO_SLIDE);
  }

  public openTerms(): void {
    this.termsAnimation = ANIMATIONS.SLIDE_IN_RIGHT;
    this.showTerms = true;
  }

  public goToHistory(): void {
    this.user$.pipe(take(1)).subscribe(user => {
      this.domManipulateService.setBodyScroll(false);
      this.router.navigate([userHistoryRoute, userHistoryDetailRoute,
        user.id, this.exchangePayload.TravelItineraryId, ReservationType.Flight]);
    }).unsubscribe();
  }

}
